<template>
  <div class="container">
    <div
      class="row justify-content-center justify-content-md-end"
      :class="rowClasses"
    >
      <div
        v-for="item in buttonsMenuItems"
        :key="item.id"
        class="col mb-3 mb-lg-0"
      >
        <router-link
          :to="item.link"
          class="
             tw-text-xs  fs-md-14
            hover:tw-text-gray-600
            tw-border tw-border-solid tw-border-gray-600
            py-2
            px-3
            tw-rounded-md
            tw-bg-white
            tw-text-gray-600
            hover:tw-bg-gray-200
            d-block
            text-center
          "
          :class="item.active ? 'tw-bg-gray-200' : ''"
          @click.native="pushDataLayer(item.name)"
        >
          {{ item.name }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import cvMixin from "@/mixins/user/cv";

  export default {
    name: "ButtonsMenu",
    mixins: [cvMixin],
    props: {
      rowClasses: {
        type: String,
        default: "row-cols-2 row-cols-lg-6",
      },
    },
    methods: {
      pushDataLayer(label) {
        window.dataLayer.push({
          event: "TrackEvent-TBO",
          category: "Somos Embajadores",
          SubCategory: "Gente en movimiento",
          Action: "Clics",
          Label: label,
        });
      },
    },
  };
</script>